import React from 'react';
import styled from 'react-emotion';
import get from 'lodash/get';

const Footer = styled('p')({
  textAlign: 'center',
  margin: 0,
  padding: '2px 0',
}, ({ theme }) => ({
  ...get(theme, 'typography.small'),
  color: get(theme, 'footer.textColor'),
}));

export default () => (
  <Footer>© Creative Corsetry.</Footer>
);



// WEBPACK FOOTER //
// ./src/structure/footer.js